@if (depositsEnabled$ | async) {
  <div class="flex flex-col">
    <h2>Appointments Awaiting Deposit</h2>

    @if (appointmentsAwaitingDeposit$ | async; as appointments) {
      @if (appointments.length) {
        <pr-content-container padding="" class="mx-4">
          <pr-appointments-awaiting-deposit-list
            [appointments]="appointments"
            (recordDeposit)="recordDeposit($event)"
            (viewAppointment)="viewAppointment($event)"
          />
        </pr-content-container>
      } @else {
        <pr-empty-state
          image="appointment"
          title="appointments awaiting deposit"
        />
      }
    }
  </div>
}
